import { documentIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { DocumentPage } from "../documents/document-page.tsx";
import { loadDocument } from "../documents/loaders.ts";
import { canBrowseDocuments } from "../documents/permissions.ts";
import { RecordPending } from "../shell/record-pending.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/documents/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null || !canBrowseDocuments(viewer) ? (
    <NoAccessPage />
  ) : (
    <DocumentPage viewer={viewer} documentId={id} />
  );
};

export const Route = createFileRoute("/_app/documents/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(documentIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadDocument(context.data, params.id),
  pendingComponent: () => <RecordPending lead="none" main="viewer" />,
  component: Page,
});
